import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhatItIsSection() {
  return <Section background="dark" data-id="element-167">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-168">
        {/* What It Is */}
        <div className="bg-slate-800/50 border border-blue-500/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-169">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-170"></div>

          <div className="flex items-center gap-3 mb-6" data-id="element-171">
            <CheckCircle2 className="h-8 w-8 text-blue-500" data-id="element-172" />
            <h3 className="text-2xl font-bold text-white" data-id="element-173">Qué ES este ebook</h3>
          </div>

          <p className="text-slate-300 text-lg leading-relaxed" data-id="element-174">
            Este ebook es un{' '}
            <span className="text-white font-semibold" data-id="element-175">sistema práctico</span>{' '}
            para convertirte en un trader más consistente: reglas, límites,
            rutinas y control emocional.
          </p>

          <div className="mt-6 flex flex-wrap gap-2" data-id="element-176">
            {['Reglas', 'Límites', 'Rutinas', 'Control'].map(tag => <span key={tag} className="px-3 py-1 bg-blue-500/10 text-blue-400 rounded-full text-sm font-medium border border-blue-500/20" data-id="element-177">
                {tag}
              </span>)}
          </div>
        </div>

        {/* What It Is NOT */}
        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 relative overflow-hidden" data-id="element-178">
          <div className="flex items-center gap-3 mb-6" data-id="element-179">
            <XCircle className="h-8 w-8 text-slate-500" data-id="element-180" />
            <h3 className="text-2xl font-bold text-slate-200" data-id="element-181">Qué NO es</h3>
          </div>

          <ul className="space-y-4" data-id="element-182">
            {['No es un ebook de señales', 'No es una estrategia secreta', 'No promete “dinero rápido”'].map((item, i) => <li key={i} className="flex items-center text-slate-400" data-id="element-183">
                <span className="w-1.5 h-1.5 bg-slate-600 rounded-full mr-3" data-id="element-184"></span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}